import React, { useContext, useRef, useState } from 'react'

import { useTranslation } from 'react-i18next'

import { TitleContext } from '@providers/TitleProvider'
import Tippy from '@tippyjs/react'
import Storage from '@utils/storage'

import PurchaseTitleDialog from '../../purchase-title-dialog/PurchaseTitleDialog'
import usePurchasePrice from '../../purchase-title-dialog/hooks/usePurchasePrice'
import SelectAuthorizedPerformers from '../../purchased-product/SelectAuthorizedPerformers'
import PurchaseButton from './PurchaseButton'

const PurchaseControls: React.FC = () => {
  const { title } = useContext(TitleContext)
  const { t } = useTranslation()

  // user may have selected a quantity, then moved through the sign-in flow
  const buyerSignInQuantity = useRef(Storage.getPurchasingQuantity(title.uuid))
  const [performers, setPerformers] = useState(buyerSignInQuantity.current || 0)

  const { price } = usePurchasePrice({
    product: title.product!,
    quantity: 1, // display unit price
  })

  return (
    <>
      <p className="pb-1 font-semibold text-md">{price.getFormattedTotal()}</p>
      <p>{t('content.cxPurchaseIncludes')}</p>
      <SelectAuthorizedPerformers title={title} value={performers} setValue={setPerformers}>
        <div className="flex flex-col">
          <div className="my-2">
            <span className="text-sm font-semibold">{t('content.authorizedPerformers.title')}</span>
            <Tippy
              arrow
              interactive
              maxWidth={270}
              placement="bottom"
              content={t('hint.purchaseScore.authorizedPerformers.maxIncluded')}
              trigger="mouseenter">
              <i className="ml-1 align-text-bottom cursor-pointer nf-icon nf-help-sign text-gray-icons dark:text-gray-icons-dm" />
            </Tippy>
          </div>
        </div>
      </SelectAuthorizedPerformers>
      <PurchaseButton />
      <PurchaseTitleDialog initialAuthorizedPerformers={performers} />
    </>
  )
}

export default PurchaseControls
